import * as React from 'react'
import { StoreProvider } from './src/contexts/store/StoreContext'

export const wrapRootElement = ({ element }) => (
  <StoreProvider>{element}</StoreProvider>
)
